module.exports = __webpack_public_path__ + "static/media/connect_wallet.c20fdeb6.svg";